import { http } from '@/utils/http';
import qs from 'qs';
const baseUrl = '/vote/2022project/q2/2022openjune/controller.php';
// const baseUrl = '/vote/2020project/2020openjune/controller.php';
const api = process.env.VUE_APP_CQCB_API;
const testApi = ''; // voteone.cqcb.com

export function getBaseInfo() {
  return http.get(`${baseUrl}?enews=base-info`);
}

// 服务端获取oss签名
export function getOssSignature() {
  return http.get('/oss/upload/get_june.php');
}

export function login(data: any) {
  const val = qs.stringify(data);
  return http.post(`${baseUrl}?enews=login`, val);
}

export function getDetail(chinaId: string | number, id: string | null) {
  return http.get(
    `${baseUrl}?enews=detail-chinaId&chinaId=${chinaId}&id=${id}`,
  );
}

export function saveData(data: any) {
  const qsData = qs.stringify(data);
  return http.post(`${baseUrl}?enews=update-save`, qsData);
}

export function updated(data: any) {
  const qsData = qs.stringify(data);
  return http.post(`${baseUrl}?enews=update`, qsData);
}

// 获取短信验证码
export function webSendMsg(data: {
  phone: number;
  sessionid: string;
  sig: string;
  token: string;
  scene: string;
  smsType: number;
}) {
  const qsData = qs.stringify(data);

  return http.post(`${api}/api/common/webSendMsg`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

// 短信code验证
export function valisendMsg(data: {
  phone: number;
  code: number;
  smsType: number;
}) {
  //  const qsData = qs.stringify(data
  return http.post(`${api}/api/common/valisendMsg`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

/*
 ***
 ** 二期api列表
 **
 */
interface IVoteListOption {
  voteName: string;
  college: string;
  sort: string;
  page?: number;
  major?: string;
  search?: string | number;
  teamType?: any;
}
export function getCollegeList() {
  return http.get(`${testApi}${baseUrl}?enews=college-rand`);
}
// 获取列表
export function getCollegeWorkList({
  page,
  college,
  search,
  major,
  sort,
}: IVoteListOption) {
  const sortBy = sort;
  return http.get(`${testApi}${baseUrl}?enews=${sortBy}`, {
    params: { page, college, search, major },
  });
}

// 专业列表
export function getMajorList(collegeId: string) {
  return http.get(`${testApi}${baseUrl}?enews=major&college_id=${collegeId}`);
}

// 作品详情
export function getWorkDetail(id: string) {
  return http.get(`${testApi}${baseUrl}?enews=detail&id=${id}`);
}

export function getPV() {
  return http.get(`${testApi}${baseUrl}?enews=Pv`);
}

// 购买按钮
export function buyInfo(id: string) {
  return http.get(`${testApi}${baseUrl}?enews=getWenTouUrl&id=${id}`);
}

// 首页轮播
export function topNewsList() {
  return http.get(`${testApi}${baseUrl}?enews=news-list-top`);
}
